export default __webpack_public_path__ + "static/media/Scales of Hardiness.6ffc2b60.jpg";